import styled from 'styled-components';
import { BoxButton } from '@riac/design-system';

export const SearchBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
  align-items: center;
  @media print {
    display: none;
  }
  padding: 12px 0px 0px 0px;

  ${(props) => `${props.theme.desktop} {
    margin-top: 25px;
  }`}

  && label {
    color: ${(props) => props.theme.black[50]};
  }
`;

export const ShowCompletedLots = styled.div`
  flex: 0 0 100%;
`;

export const SearchBars = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${(props) => `${props.theme.phone} {
    flex-wrap: nowrap;
  }`}
`;

export const KeywordSearch = styled.div`
  flex-basis: 900px;
  flex-shrink: 5;
  flex-grow: 1;
  margin-right: 30px;
  max-width: 500px;
`;

export const LotSearch = styled.div`
  flex-basis: 180px;
  flex-shrink: 0.5;
  flex-grow: 1;
  margin-right: 2px;
  max-width: 200px;
`;

export const CompactToggle = styled.div`
  display: none;
  ${(props) => `${props.theme.desktop} {
    display: block;
  }`}
`;

export const SearchButton = styled(BoxButton)`
  line-height: 1;
  padding: 0px 13px;
  display: inline-flex;
  svg {
    margin-right: 10px;
    margin-bottom: 4px;
  }
  height: 100%;
`;

export const GoButton = styled(BoxButton)`
  line-height: 1;
  padding: 0px 13px;
  display: inline-flex;
  svg {
    margin-bottom: 4px;
  }
  height: 100%;
`;
